import type { ReactNode } from 'react';

export interface NoticeProps {
  children: ReactNode;
  tone?: 'neutral' | 'ok' | 'partial' | 'fail';
}

export function Notice({ children, tone = 'neutral' }: NoticeProps) {
  const classes = ['fs-notice'];
  if (tone !== 'neutral') classes.push(`fs-notice--${tone}`);
  return (
    <div className={classes.join(' ')} role={tone === 'fail' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
